var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "content w-full xl:!w-[55%]",
    class: _vm.setClass
  }, [_c('div', {
    staticClass: "inner-content h-full p-4 xl:p-[2.5rem_5rem]"
  }, [_c('div', {
    staticClass: "flex flex-col xl:flex-row items-start xl:items-center justify-center h-full"
  }, [_vm._t("content")], 2)])]);
};

var staticRenderFns = [];
export { render, staticRenderFns };